import React, {Component}   from 'react';
import {
  Panel,
  Row,
  Col
}                           from 'react-bootstrap';

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';

import Filter               from './Filter';
import Tab                  from './Tab';

import saveTrail            from '../../utils/saveTrail';

class AccessRight extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterUser: null,
      isLoading: false,
      checkboxes: [],
      isSaving: false
    };

    this.stateSetter = this.stateSetter.bind(this);
    this.getAccessList = this.getAccessList.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.save = this.save.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  stateSetter(stateArray) {
    for (var i in stateArray) {
      this.setState({ [stateArray[i].state]: stateArray[i].value }, () => {
        if (stateArray[i].state === 'filterUser') {
          this.getAccessList();
        }
      });
    }
  }

  loadOptions(input, cb) {
    var query = new Parse.Query(Parse.User);
    query.matches('name', input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');

    query.limit(20);
    query.find()
    .then((data) => {
      return data.map((item) => item = {
        label: (typeof item.get('name') !== 'undefined') ? item.get('name') : '',
        value: item.id
      });
    })
    .then((data) => {
      cb(null, {options: data});
    })
    .catch((err) => {
      console.log('Load Select Options error: ', err.message);
    });
  }

  getAccessList() {
    let {
      filterUser
    } = this.state;

    if (filterUser !== null) {
      this.setState({ isLoading: true });

      var User = Parse.Object.extend(Parse.User),
          user = new User();
      user.id = filterUser.value;

      var accessListQuery = new Parse.Query('AccessListWeb');
      accessListQuery.include(['ModulesWeb', 'Actions', 'Apps']);

      var apssQuery = new Parse.Query('Apps');
      apssQuery.equalTo('name','RWM CMS');

      accessListQuery.matchesQuery('Apps', apssQuery);

      var accessRightQuery = new Parse.Query('AccessRightsWeb');
      accessRightQuery.include(['AccessListWeb.ModulesWeb', 'AccessListWeb.Actions', 'AccessListWeb.Apps']);
      accessRightQuery.matchesQuery('AccessListWeb', accessListQuery);
      accessRightQuery.equalTo('User', user);

      Promise.all([
        accessListQuery.count(),
        accessRightQuery.count()
      ])
      .then(([count, count_right]) => {
        accessListQuery.limit(count);
        accessRightQuery.limit(count_right);
        return Promise.all([accessListQuery.find(), accessRightQuery.find()]);
      })
      .then((data) => {
        // console.log('getAccessList result: ', data);
        var accessList = data[0],
            accessRight = data[1],
            json = [];

        for (let obj of accessList) {
          // console.log('accessList: ', obj);
          var index = json.map(e => e.module).indexOf(obj.get('ModulesWeb').get('name')),
              b = false;
          for (let a of accessRight) {
            // console.log('accessRight: ', a);
            if (a.get('AccessListWeb').get('ModulesWeb').get('name').toUpperCase() === obj.get('ModulesWeb').get('name').toUpperCase() && a.get('AccessListWeb').get('Actions').get('name').toUpperCase() === obj.get('Actions').get('name').toUpperCase()) {
              b = true;
              // console.log(true);
              break;
            }
          }

          if (index == -1) {
            json.push({
              module: obj.get('ModulesWeb').get('name'),
              actions: [
                {
                  accesslistId: obj.id,
                  action: obj.get('Actions').get('name'),
                  access: b
                }
              ]
            })
          } else {
            var index2 = json[index].actions.map(e => e.action).indexOf(obj.get('Actions').get('name'));
            if (index2 == -1) {
              json[index].actions.push({
                accesslistId: obj.id,
                action: obj.get('Actions').get('name'),
                access: b
              });
            }
          }
        }
        // console.log('json: ', json);
        this.setState({checkboxes: json, isLoading: false});
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log('getAccessList error: ', err.message);
      });
    } else {
      // select user is empty
      this.setState({ checkboxes: [] });
    }
  }

  toggleCheckbox(mod, actionIndex, action) {
    let {checkboxes} = this.state;
    let json = checkboxes;

    let index = json.map(e => e.module).indexOf(mod);

    if (index != -1) {
      json[index].actions[actionIndex].access = !action.access
    }

    this.setState({checkboxes: json});
  }

  save() {
    let {
      filterUser,
      checkboxes,
      isSaving
    } = this.state;

    this.setState({ isSaving: true });

    const isNull = (obj) => obj == null
      ? true
      : false;
    const getValue = (obj) => isNull(obj)
      ? ''
      : obj.value;

    var userId = getValue(filterUser),
        User = Parse.Object.extend(Parse.User),
        user = new User();

    user.id = userId;

    var appsQuery = new Parse.Query('Apps');
    appsQuery.equalTo('name','RWM CMS');

    var accessListQuery = new Parse.Query('AccessListWeb');
    accessListQuery.matchesQuery('Apps', appsQuery);

    var accessRightQuery = new Parse.Query('AccessRightsWeb');
    accessRightQuery.equalTo('User', user);
    accessRightQuery.matchesQuery('AccessListWeb', accessListQuery);

    accessRightQuery.count()
    .then((count) => {
      console.log('count: ', count);
      accessRightQuery.limit(count);
      return accessRightQuery.find();
    })
    .then((data) => {
      console.log('data: ', data);
      return Parse.Object.destroyAll(data);
    })
    .then((data) => {
      console.log('data: ', data);
      var accessRights = [];
      for (var right of checkboxes) {
        for (var action of right.actions) {
          if (action.access) {
            var AccessListWeb = Parse.Object.extend('AccessListWeb'),
                accessListWeb = new AccessListWeb();
            accessListWeb.id = action.accesslistId;

            var AccessRightsWeb = Parse.Object.extend('AccessRightsWeb'),
                accessRightsWeb = new AccessRightsWeb();
            accessRightsWeb.set('AccessListWeb', accessListWeb);
            accessRightsWeb.set('User', user);

            accessRights.push(accessRightsWeb);
          }
        }
      }

      return Parse.Object.saveAll(accessRights);
    })
    .then((data) => {
      saveTrail('UPDATE', {
        User: ((data[0].get('User').get('name')) ? data[0].get('User').get('name') : '')
      });
      this.setState({ isSaving: false }, () => {
        this.getAccessList();
      });
    })
    .catch((err) => {
      console.log('Saving access rights error: ', err.message);
      this.setState({ isSaving: false });
    });
  }

  accessible(actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

  render() {
    let {
      filterUser,
      isLoading,
      checkboxes,
      isSaving
    } = this.state;

    let filterProps = {
      filterUser,
      isSaving,
      checkboxes,
      stateSetter: this.stateSetter,
      loadOptions: this.loadOptions,
      save: this.save,
      accessible: this.accessible
    };

    let tabProps = {
      checkboxes,
      isLoading,
      toggleCheckbox: this.toggleCheckbox
    };

    return (
      <Panel>
        <Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
					<h4>Access Right</h4>
				</Panel.Heading>
        <Panel.Body>
          <Filter {...filterProps} />
          <Tab {...tabProps} />
        </Panel.Body>
      </Panel>
    );
  }
}

function mapStateToProps(state) {
	var {accessjson} = state;
	const props = {
    accessjson
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch)
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessRight);



// WEBPACK FOOTER //
// ./components/AccessRight/index.js